/**
 * ProfileTabs — semi-sticky editorial tab nav below the header. Text +
 * underline, no filled pill buttons, mirroring AppHeader's active-link
 * treatment (layoutId-animated coral underline).
 */

import React from 'react';
import { motion } from 'framer-motion';
import { cx } from '@/components/site/primitives';
import { PROFILE_TABS } from './constants';
import { PROFILE } from '@/constants/testIds';

export default function ProfileTabs({ active, onChange }) {
  return (
    <nav
      aria-label="Profile sections"
      data-testid={PROFILE.tabs}
      className="sticky top-16 z-30 mt-8 border-b border-line bg-cream/90 backdrop-blur-xl"
    >
      <div className="u-container flex items-center gap-1 overflow-x-auto scrollbar-none">
        {PROFILE_TABS.map((tab) => {
          const isActive = tab.key === active;
          return (
            <button
              key={tab.key}
              type="button"
              onClick={() => onChange(tab.key)}
              data-testid={PROFILE.tab(tab.key)}
              aria-current={isActive ? 'page' : undefined}
              className="group relative shrink-0 whitespace-nowrap px-4 py-3.5 text-[15px] font-medium transition-colors focus-visible:outline-none"
            >
              <span className={cx(isActive ? 'font-semibold text-coral' : 'text-ink/70 group-hover:text-coral')}>
                {tab.label}
              </span>
              {isActive && (
                <motion.span
                  layoutId="profile-tab-active-indicator"
                  transition={{ type: 'spring', stiffness: 400, damping: 32 }}
                  className="absolute inset-x-4 bottom-0 h-[2px] rounded-full bg-coral"
                />
              )}
            </button>
          );
        })}
      </div>
    </nav>
  );
}
